import './Popup.scss';

export default function EditUserPopupNone({ onClick, errorText = 'Something went wrong' }) {
    return (
        <div className='popup_container' >
            <div className='white_block' >
                <h3>{errorText}</h3>

                <button
                    onClick={onClick}
                >
                    Ok
                </button>


            </div>
        </div>
    )
}
